"use client";

import {
  Box,
  Grid2,
  Pagination,
  SearchBox,
  Tab,
  TabList,
  TabPanel,
  Tabs,
  Typography,
} from "@repo/ui";
import { useState } from "react";
import Section from "../components/Section";
import CourseCard from "../components/CourseCard";
import { COURSES } from "@repo/shared-data";

const CategorizedBlogs = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalItems = 100;
  const itemsPerPage = 10;

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const data = COURSES;

  return (
    <Section>
      <Box>
        <Tabs defaultValue={1}>
          <TabList className="text-gray-500">
            <Tab className="!text-base" value={1}>
              All
            </Tab>
            <Tab className="!text-base" value={2}>
              Agile & Scrum
            </Tab>
            <Tab className="!text-base" value={3}>
              Devops
            </Tab>
            <Tab className="!text-base" value={4}>
              Leadership & Professional Development
            </Tab>
            <Tab className="!text-base" value={5}>
              Quality Management
            </Tab>
            <Tab className="!text-base" value={6}>
              Development & Testing
            </Tab>
            <Tab value={7} className="!text-base">
              +10 more
            </Tab>
          </TabList>

          <TabPanel value={1}>
            <Grid2 container spacing={5}>
              <Grid2 size={{ sm: 12, md: 12, lg: 12 }}>
                <Box flex justifyContent="between" className="!my-4">
                  <Typography>Showing 143 Results</Typography>
                  <Box>
                    <SearchBox />
                  </Box>
                </Box>
              </Grid2>
              {data.map((currentCourse, idx) => (
                <Grid2 size={{ sm: 6, md: 4, lg: 4 }} key={idx}>
                  <CourseCard {...currentCourse} isAuthor />
                </Grid2>
              ))}
            </Grid2>
          </TabPanel>
          <TabPanel value={2}>
            <Grid2 container spacing={5}>
              {data.map((currentCourse, idx) => (
                <Grid2 size={{ sm: 6, md: 4, lg: 4 }} key={idx}>
                  <CourseCard {...currentCourse} isAuthor />
                </Grid2>
              ))}
            </Grid2>
          </TabPanel>
          <TabPanel value={3}>
            <Grid2 container spacing={5}>
              {data.map((currentCourse, idx) => (
                <Grid2 size={{ sm: 6, md: 4, lg: 4 }} key={idx}>
                  <CourseCard {...currentCourse} isAuthor />
                </Grid2>
              ))}
            </Grid2>
          </TabPanel>
          <TabPanel value={4}>
            <Grid2 container spacing={5}>
              {data.map((currentCourse, idx) => (
                <Grid2 size={{ sm: 6, md: 4, lg: 4 }} key={idx}>
                  <CourseCard {...currentCourse} isAuthor />
                </Grid2>
              ))}
            </Grid2>
          </TabPanel>
          <TabPanel value={5}>
            <Grid2 container spacing={5}>
              {data.map((currentCourse, idx) => (
                <Grid2 size={{ sm: 6, md: 4, lg: 4 }} key={idx}>
                  <CourseCard {...currentCourse} isAuthor />
                </Grid2>
              ))}
            </Grid2>
          </TabPanel>
          <TabPanel value={6}>
            <Grid2 container spacing={5}>
              {data.map((currentCourse, idx) => (
                <Grid2 size={{ sm: 6, md: 4, lg: 4 }} key={idx}>
                  <CourseCard {...currentCourse} isAuthor />
                </Grid2>
              ))}
            </Grid2>
          </TabPanel>
          <TabPanel value={7}>
            <Grid2 container spacing={5}>
              {data.map((currentCourse, idx) => (
                <Grid2 size={{ sm: 6, md: 4, lg: 4 }} key={idx}>
                  <CourseCard {...currentCourse} isAuthor />
                </Grid2>
              ))}
            </Grid2>
          </TabPanel>
        </Tabs>
      </Box>

      <Box>
        <Pagination
          count={totalItems}
          itemsPerPage={itemsPerPage}
          page={currentPage}
          onPageChange={handlePageChange}
        />
      </Box>
    </Section>
  );
};
export default CategorizedBlogs;
